<div class="notifications-wrapper position-fixed"
     [ngClass]="position"
     (mouseenter)="this.isPaused$.next(true);"
     (mouseleave)="this.isPaused$.next(false);">
  <ds-notification
    class="notification"
    *ngFor="let a of notifications; let i = index"
    [notification]="a" [isPaused$]="isPaused$">
  </ds-notification>
</div>

<div class="notifications-wrapper position-fixed bottom right">
  <ds-process-notification
    class="notification"
    *ngFor="let procNotification of processNotifications; let ix = index"
    [notification]="procNotification">
  </ds-process-notification>
</div>
